import { IsBoolean, IsDate, IsDefined, IsIn, IsString } from 'class-validator';
import { STRIPE_SUBSCRIPTION_STATUSES, StripeSubscriptionStatus, SubscriptionId } from '../../types';

export class UserSubscriptionDto {
  @IsDefined()
  @IsString()
  _id!: SubscriptionId;

  @IsDefined()
  plan!: unknown;

  @IsDefined()
  @IsString()
  @IsIn(STRIPE_SUBSCRIPTION_STATUSES)
  status!: StripeSubscriptionStatus;

  @IsDefined()
  @IsDate()
  currentPeriodStart!: Date;

  @IsDefined()
  @IsDate()
  currentPeriodEnd!: Date;

  @IsDefined()
  @IsBoolean()
  cancelAtPeriodEnd!: boolean;
}
